import React from 'react'
import Spacer from '../components/general/Spacer'
import Media from './Media'

const Breakout = ({ options }) => {
    return (
        <>
            <Spacer spacing={options.spacing}>
                <Media options={options} />
            </Spacer>
        </>
    )
}

export default Breakout
